import CrossIcon from 'components/icons/CrossIcon';
import React from 'react';

const CSS = require('./Pill.module.scss');

interface PillProps {
  onRemove: (keyword: string) => void;
  name: string;
}

function Pill({ name, onRemove }: PillProps) {
  if (!name) {
    return null;
  }
  const onClick = () => onRemove(name);

  return (
    <button key={name} className={CSS.Pill} onClick={onClick}>
      {name}
      <span className={CSS.CrossIconContainer}>
        <CrossIcon className={CSS.CrossIcon} width={8} height={8} />
      </span>
    </button>
  );
}

export default Pill;
